import { Component, Output, Input, EventEmitter } from '@angular/core';
import { VSTLabelEvent } from '../../../interfaces/VST';

@Component({
  selector: 'vst-label',
  moduleId: module.id,
  templateUrl: './vst-label.component.html',
})
export class VstChartLabelComponent {
  @Output() displayLabel = new EventEmitter<VSTLabelEvent>();
  @Input('display') displayState: boolean;
  @Input() key: string;
  @Input() label: string;
  @Input() value: string;
  @Input() tooltip: string;

  constructor() {}

  updateState() {
    this.displayState = !this.displayState;
    this.displayLabel.emit({
      series: this.key,
      label: this.label,
      displayState: this.displayState,
    });
  }
}
